'use client';

import { useLocale } from 'next-intl';
import { usePathname } from 'next/navigation';
import { WorkspaceAdmissionShell } from '@/components/workspace-admission-shell';
import { resolveWorkspaceAdmissionShellVariant } from '@/components/workspace-admission-shell-variant';
import { FullScreenLoader } from '@/components/loaders';
import { getLoaderCopy } from '@/i18n/loader-copy';
import {
  useAuthHandoffHold,
  useAuthHandoffState,
} from '@/lib/auth/auth-handoff';

/** Shared auth loading surface, including Electron's remote product pages. */
export function RouteLoading() {
  const copy = getLoaderCopy(useLocale());
  const handoff = useAuthHandoffState();
  // During a sign-in handoff the veil is the one loader: this paints nothing
  // of its own (no second spinner, no copy in the pre-sign-in locale) and
  // only keeps the veil up while the route loads (#5559).
  const underVeil = handoff.active && !handoff.yielded;
  useAuthHandoffHold(underVeil);
  // Workspace routes with the default sidebar get the same frame the
  // workspace boundary shows next, so a reload goes straight to the page's
  // shape instead of a centred spinner that is then replaced.
  const variant = resolveWorkspaceAdmissionShellVariant(usePathname());
  if (underVeil)
    return <div aria-hidden className="bg-background min-h-dvh w-full" />;
  if (variant !== 'generic')
    return <WorkspaceAdmissionShell variant={variant} />;
  return <FullScreenLoader message={copy.movingAlong} />;
}
